import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const CheckBoxSelect = (props) => {
   const { classes, checkboxValue, checkboxLabel, checked } = props;
   const handleCheckboxChange = (event) => {
      const { checkboxChangeCallback } = props;
      checkboxChangeCallback(event.target.checked);
   };
   return (
      <FormControlLabel
         control={
            <Checkbox
               checked={checked}
               onChange={handleCheckboxChange}
               value={checkboxValue}
               // classes={{
               //   root: classes.root,
               //   checked: classes.checked,
               // }}
               {...props}
            />
         }
         label={checkboxLabel}
      />
   );
};

export default CheckBoxSelect;
